import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Field = ({ className, size, isError, children, ...props }) => (
  <div
    className={classNames(
      'field',
      `field--${size || 'md'}`,
      isError && 'field--error',
      className,
    )}
    {...props}
  >
    {children}
  </div>
);

Field.Label = ({ className, children, ...props }) => (
  <label className={classNames('field__label', className)} {...props}>
    {children}
  </label>
);

Field.Input = forwardRef(({ className, multiline, ...props }, ref) => {
  const Component = multiline ? 'textarea' : 'input';

  return (
    <Component
      className={classNames('field__input', className)}
      ref={ref}
      {...props}
    />
  );
});

Field.Error = ({ className, children, ...props }) => (
  <div className={classNames('field__error', className)} {...props}>
    {children}
  </div>
);

Field.Label.displayName = 'Field.Label';
Field.Input.displayName = 'Field.Input';
Field.Error.displayName = 'Field.Error';

Field.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf([
    'sm',
    'md',
    'lg',
  ]),
  isError: PropTypes.bool,
  children: PropTypes.node,
};

Field.Label.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

Field.Input.propTypes = {
  className: PropTypes.string,
  multiline: PropTypes.bool,
};

Field.Error.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Field;
